module.exports = __webpack_public_path__ + "img/menuIcon9.8c27ea0a.png";